require("../../../static/js/episerver-forms.js");
require("../../../static/js/membership-global.js");
require("../../../static/js/register-individual-investor-form.js");
require("../../../static/js/global-form.js");
